import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import {
  getDataProvideAgreeSeq,
  KEY_DEEPLINKHASH,
  KEY_GOODSHASH,
  KEY_ACCESS_URL,
  KEY_DATAPROVIDEAGREESEQ,
} from 'tools/WebTool';
import { getDataRequest, modifyDataRequest } from 'utils/request';
import ROUTE_PATH from 'routes/config';
import DataProviderTable from 'pages/MyPage/LoanLimit/LoanLimitBasicPage/DataProviderTable';
import StyledActiveButton from 'components/Button/StyledActiveButton';
import { LoadingBar } from 'components/LoadingIndicator';
import CheckableTypeStipulation from 'components/CheckableTypeStipulation';
import TextTypeStipulation from 'components/TextTypeStipulation';
import {
  KEY_GUIDE,
  INIT_AGREE_DETAIL_DATA,
  getOneBtnModalMessage,
  getNoBtnModalMessage,
} from './constants';
import {
  TextMedium,
  ColorSpan,
  TextButton,
  TextLeftAlign,
  NoticeTitle,
  List,
  Text,
  InfoToolTip,
  ColorSpanRed,
  DisagreeNoticeBox,
  Contents,
  DeepLinkAgreeWrapper,
} from './style';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';
import { useApp } from 'contexts/AppContext';
import { useUI } from 'contexts/UIContext';
import Layout from '../../../layout';

const DeepLinkAgreePage = () => {
  const { auth } = useApp();
  const { setModalData, setContextLoading } = useUI();
  const { deepLink } = ROUTE_PATH;
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, _] = useSearchParams();

  // api 통신 로딩 (로딩 중: true) - 더블클릭 방지
  const [isApiLoading, setIsApiLoading] = useState(false);
  //데이터 제공동의 데이터
  const [agreeDetailData, setAgreeDetailData] = useState(
    INIT_AGREE_DETAIL_DATA
  );
  const [sellerMallList, setSellerMallList] = useState([]);
  const [targetMallList, setTargetMallList] = useState([]);
  const [essentialMallText, setEssentialMallText] = useState('');
  // 약관 데이터
  const [stipulationList, setStipulationList] = useState([]);
  //alert
  const [errorNo, setErrorNo] = useState(0);
  const [onlyModal, setOnlyModal] = useState(false); //컨텐츠 없이 모달창만 띄우기
  const [detailSeq, setDetailSeq] = useState({});

  // 데이터 제공 동의 타입 - DEFAULT: 일반 / ADD_MALL: 담보몰 추가
  const dataAgreeType =
    searchParams.get('type') === 'add-mall' ? 'ADD_MALL' : 'DEFAULT';
  // 약관 타입 - 체크박스 타입(STC100), 텍스트 타입(STC200)
  const isCheckBoxType = stipulationList[0]?.stipulationTypeCd === 'STC100';
  // 정적 딥링크 생성 에러 데이터
  const goodsData = location?.state?.goodsData || {};
  // 동의하기 버튼 비활성화 여부
  const isAgreeBtnDisabled = stipulationList.some(
    item => item.essentialYn === 'Y' && !item.checked
  );
  const localDataProvideAgreeSeq = getDataProvideAgreeSeq();
  const isLogin = auth.authenticated;

  const getAddMallAgreeRequest = () => {
    getDataRequest({
      url: 'v1/au/data-provide-agree/add-mall',
      successFnc: (data = {}) => {
        setAgreeDetailData({ ...data.result, dataProvideType: 'SECURED' });
        setSellerMallList(data.result.addMallList || []);
        setStipulationList(prepareStipulationData(data.result.stipulationList));
      },
      setIsLoading: setContextLoading,
      errorFnc: data => {
        // 기한만료, 데이터이용종료
        setModalData(getModalData('etcCase', getOneBtnModalMessage(data)));
      },
      exceptFnc: message => {
        setOnlyModal(true);
        setModalData({
          contents: getNoBtnModalMessage(message),
          onClickCloseBtn: () => navigate('/'),
        });
      },
    });
  };

  const getDataProviderAgreeRequest = () => {
    //get 데이터 제공 동의 데이터 - 공통 에러 함수
    const getDataErrorFnc = (data, message, errorNo) => {
      setErrorNo(errorNo);

      const targetMallByCreditGoodsMallList =
        data?.creditGoodsMallList?.length > 0
          ? data?.creditGoodsMallList
          : [{ mallSeq: 0, mallName: '전체 몰' }];

      // Case1 : 데이터 제공 기한 만료 (3-1) / 사업자가 일치하지 않는 경우(동적 링크)
      if (errorNo === 100) {
        //기한만료, 사업자불일치
        setOnlyModal(true);
        setModalData(getModalData('etcCase', message));
      }

      // Case2 : 판매몰 연동 X (5-1)
      else if (errorNo === 200) {
        setModalData(getModalData('zeroInterlockedMall', message));
        setAgreeDetailData({
          ...data?.result,
        });
        const targetMallList =
          data?.requestMallList?.length > 0
            ? data?.requestMallList
            : [{ mallSeq: 0, mallName: '전체 몰' }];

        setTargetMallList(targetMallList);
        setEssentialMallText('');
      }

      // Case3 : 금융기관이 요청한 필수타겟몰이 연동되어있지 않을 경우 (6-2) - 필수몰이 있는 경우
      else if (errorNo === 300) {
        setSellerMallList(data?.list || []);
        setAgreeDetailData({
          ...data.result,
        });
        const targetMallList =
          data?.result?.mallList?.length > 0
            ? data?.result?.mallList
            : targetMallByCreditGoodsMallList;

        setTargetMallList(targetMallList);
        setEssentialMallText('아래 판매몰 모두 판매 연동을 진행해 주세요.');

        // Case4 : 금융기관이 요청한 상품타겟몰이 연동되어 있지 않을 경우 (6-2) - 타겟몰이 있는 경우
      } else if (errorNo === 400) {
        setSellerMallList(data?.list || []);
        setTargetMallList(targetMallByCreditGoodsMallList);
        setAgreeDetailData({
          ...data?.result,
        });
        setEssentialMallText(
          '아래 판매몰 중 1개 이상 판매 연동을 진행해 주세요.'
        );

        // 데이터 이용중인 경우 (동의한 약관 존재 O) - status: 200, success: false
      } else {
        setOnlyModal(true);
        setModalData({
          contents: message,
          onClickCloseBtn: () => navigate('/'),
        });
      }
    };

    getDataRequest({
      url: `/v1/au/data-provide-agree/${localDataProvideAgreeSeq}`,
      errorFnc: getDataErrorFnc,
      successFnc: (data = {}) => {
        setStipulationList(prepareStipulationData(data.stipulationList));
        setAgreeDetailData({
          ...data.result,
        });
        setSellerMallList(data?.list || []);
      },
      setIsLoading: setContextLoading,
    });
  };

  const modifyDataProvideAgreeRequest = () => {
    const successFnc = async () => {
      await navigate(ROUTE_PATH.deepLink.agreeComplete);
    };

    modifyDataRequest({
      url: `/v1/au/data-provide-agree/agree/${agreeDetailData?.dataProvideAgreeSeq}`,
      data: {
        dataProvideAgreeStipulationTypeCd:
          stipulationList[0]?.stipulationTypeCd,
        agreeList: [
          ...stipulationList.map(({ stipulationSeq, checked }) => ({
            stipulationSeq,
            agreeYn: checked === true ? 'Y' : 'N',
          })),
        ],
        mallList:
          agreeDetailData?.dataProvideType === 'SECURED'
            ? sellerMallList.map(item => ({
                mallSeq: item.mallSeq,
                mallAccountId: item.mallAccountId,
                settlementBeginDate: item.settlementBeginDate,
                settlementEndDate: item.settlementEndDate,
              }))
            : [],
      },
      successFnc: successFnc,
      setModalMessage: message =>
        setModalData({
          contents: message,
          onClickCloseBtn: () => navigate('/'),
        }),
      setIsLoading: setIsApiLoading,
    });
  };

  const modifyAddMallAgreeRequest = () => {
    const successFnc = async (
      data = {
        businessName: '',
        financeInstitutionName: '',
        creditRequestSeq: 0,
        dataProvideAgreeSeq: 0,
        mallNameList: [],
        errorCode: '',
      },
      message = ''
    ) => {
      setModalData(getModalData('checkAddMall', message));
      setDetailSeq({
        creditRequestSeq: data.creditRequestSeq,
        dataProvideAgreeSeq: data.dataProvideAgreeSeq,
      });
    };
    const errorFnc = (
      data = {
        businessName: '',
        financeInstitutionName: '',
        mallNameList: [],
        errorCode: '',
      }
    ) => {
      const { errorCode, businessName, financeInstitutionName, mallNameList } =
        data.data;
      if (errorCode === 'NOT_LINK_MALL') {
        const message = `<p><span style="font-weight: 650">${businessName}</span> 고객님,<br /><br />데이터 제공 동의 요청한 판매몰이 연동완료 되지 않아 데이터 제공 동의가 불가합니다.<br /><br /><span style="font-weight: 650">${mallNameList.join(
          ', '
        )}</span> 판매몰 연동 후 다시 한번 진행 부탁드립니다.<br /><br />[진행 방법]<br /><ol style="padding: 0 0 0 10px"><li>'데이터 연동하기' 버튼 클릭 후 요청한 판매몰을 연동해주세요.</li><li>판매몰 연동 후 데이터 제공 동의 요청 문자 URL로 다시 접속하여 동의 절차를 다시 진행해 주세요.</li></ol></p>`;

        setModalData(getModalData('notLinkMall', message));
      } else if (errorCode === 'ALREADY_USED_MALL') {
        const message = `<p><span style="font-weight: 650">${businessName}</span> 고객님,<br /><span style="font-weight: 650">${financeInstitutionName}</span>의 대출 신청을 위한<br/>추가 데이터 제공 동의 판매몰 중 <span style="font-weight: 650">${mallNameList.join(
          ', '
        )}</span> 판매몰이 이미 데이터 이용중 입니다.<br /><br /><span style="font-weight: 650">${financeInstitutionName}</span>에 다시 한번 문의 부탁드립니다.</p>`;

        setModalData(getModalData('alreadyUsedMall', message));
      } else if (errorCode === 'NO_EXIST_AMT') {
        const message = `<p><span style="font-weight: 650">${businessName}</span> 고객님,<br /><span style="font-weight: 650">${financeInstitutionName}</span>의 대출 신청을 위한<br/>추가 데이터 제공 동의 판매몰 중 <span style="font-weight: 650">${mallNameList.join(
          ', '
        )}</span> 판매몰이 정산 예정금이 없습니다.<br /><br/><span style="font-weight: 650">${financeInstitutionName}</span>에 다시 한번 문의 부탁드립니다.<br /><br/><span style="color: red; font-weight: 300;">⚠금융기관에서 요청한 시점의 정산예정금과 현재 시점의 정산예정금이 달라 정산예정금이 없을 수 있습니다.</span></p>`;
        setModalData(getModalData('noExistAmt'), message);
      } else {
        setModalData({
          contents: '에러가 발생했습니다.\n고객센터로 문의해주세요.',
          onClickCloseBtn: () => navigate('/'),
        });
      }
    };
    modifyDataRequest({
      url: `/v1/au/data-provide-agree/add-mall/agree/${agreeDetailData?.dataUseAdditionRequestSeq}`,
      data: {
        dataProvideAgreeStipulationTypeCd:
          stipulationList[0]?.stipulationTypeCd,
        agreeList: [
          ...stipulationList.map(({ stipulationSeq, checked }) => ({
            stipulationSeq,
            agreeYn: checked === true ? 'Y' : 'N',
          })),
        ],
      },
      successFnc: successFnc,
      errorFnc: errorFnc,
      setModalMessage: message =>
        setModalData({
          contents: message,
          onClickCloseBtn: () => navigate('/'),
        }),
      setIsLoading: setIsApiLoading,
    });
  };

  const prepareStipulationData = data => {
    const rawList = data || [];
    const checkedType = rawList[0]?.stipulationTypeCd === 'STC100';
    const processedList = rawList
      .map(item => ({
        ...item,
        required: item.essentialYn === 'Y',
        checked: false,
      }))
      .sort((a, b) => b.required - a.required); // 필수 먼저

    return checkedType ? processedList : rawList;
  };

  const handleApiError = () => {
    setContextLoading(false);
    // 미확인, 제공불가 존재
    if (
      (goodsData.errorCode === 'UNIDENTIFIED_EXIST' ||
        goodsData.errorCode === 'UNAVAILABLE_EXIST') &&
      !localDataProvideAgreeSeq
    ) {
      if (!!goodsData.dataProvideAgreeSeq) {
        localStorage.setItem(
          KEY_DATAPROVIDEAGREESEQ,
          goodsData.dataProvideAgreeSeq
        );
      }
      setOnlyModal(true);
      setModalData(getModalData('etcCase', goodsData.message, 500)); // 프론트에서 임의로 errorNo 500 설정
    }

    // 이용중이거나 필수몰 유효성 체크 실패
    if (
      (goodsData.errorCode === 'ALREADY_USING' ||
        goodsData.errorCode === 'ESSENTIAL_MALL_NOT_VALIDATE') &&
      !localDataProvideAgreeSeq
    ) {
      setOnlyModal(true);
      setModalData({
        contents: goodsData.message,
        onClickCloseBtn: () => navigate('/'),
      });
    }

    //방어 코드
    localStorage.removeItem(KEY_GOODSHASH);
    localStorage.removeItem(KEY_ACCESS_URL);
    localStorage.removeItem(KEY_DEEPLINKHASH);
  };

  //타겟 판매몰 매칭 불가 케이스
  const isDisagreeCase =
    agreeDetailData &&
    targetMallList?.length > 0 &&
    (errorNo === 300 || errorNo === 400 || errorNo === 200);

  //동의하기
  const onClickAgreeBtn = type => {
    if (type === 'DEFAULT') {
      modifyDataProvideAgreeRequest();
    } else if (type === 'ADD_MALL') {
      modifyAddMallAgreeRequest();
    } else {
      return null;
    }
  };

  // 로그인 페이지로 이동
  const goToLoginPage = () => {
    const search = `?redirect-to=${ROUTE_PATH.deepLink.agree}?type=add-mall`;
    navigate(ROUTE_PATH.login.login + search);
  };

  // 모달 데이터
  const getModalData = (modalName, message = '', errorNo = 0) => {
    const modalDataMap = {
      // 데이터 제공 동의 거절
      rejectAgreement: {
        contents: `데이터 제공 동의를 거절하시겠어요?
        데이터 제공 동의 거절 시 금융기관에
        데이터를 제공할 수 없습니다.`,
        cancelBtnName: '닫기',
        confirmBtnName: '거절하기',
        onClickConfirmBtn: () => {
          setModalData(null);
          if (dataAgreeType === 'ADD_MALL') {
            modifyDataRequest({
              url: `/v1/au/data-provide-agree/add-mall/disagree/${agreeDetailData.dataUseAdditionRequestSeq}`,
              setModalMessage: message =>
                setModalData({
                  contents: message,
                  onClickCloseBtn: () => navigate('/'),
                }),
            });
          } else {
            modifyDataRequest({
              url: `/v1/au/data-provide-agree/disagree/${localDataProvideAgreeSeq}`,
              setModalMessage: message =>
                setModalData({
                  contents: message,
                  onClickCloseBtn: () => navigate('/'),
                }),
            });
          }
        },
      },
      // 추가 담보몰 제공 동의 거절
      // 판매몰 등록 여부 0건(error 200)
      zeroInterlockedMall: {
        contents: message,
        cancelBtnName: '닫기',
        onClickCancelBtn: () => navigate('/'),
        confirmBtnName: '데이터 연동하기',
        onClickConfirmBtn: () => navigate(ROUTE_PATH.mypage.dataLinkageManage),
      },
      // 동의 완료 (1-4-a 상품타겟몰이 있는 경우)
      dataInterlock: {
        contents: message,
        cancelBtnName: '닫기',
        onClickCancelBtn: () => navigate('/'),
        confirmBtnName: '데이터 연동하기',
        onClickConfirmBtn: () => navigate(ROUTE_PATH.mypage.dataLinkageManage),
      },
      // 동의 완료 (1-4-b 상품타겟몰이 없는 경우) - 모달->페이지이동으로 변경 사용하지 않음, 차후 삭제
      dataProvideAgree: {
        contents: message,
        cancelBtnName: '닫기',
        onClickCancelBtn: () => navigate('/'),
        confirmBtnName: '데이터 제공 관리',
        onClickConfirmBtn: () =>
          navigate(`${ROUTE_PATH.mypage.manageLoanDataProvide}?tab=dataUse`),
      },
      // dataAgreeType: ADD_MALL
      notLinkMall: {
        contents: message,
        cancelBtnName: '닫기',
        onClickCancelBtn: () => navigate('/'),
        confirmBtnName: '데이터 연동하기',
        onClickConfirmBtn: () => navigate(ROUTE_PATH.mypage.dataLinkageManage),
      },

      alreadyUsedMall: {
        contents: message,
        cancelBtnName: '닫기',
        onClickCancelBtn: () => navigate('/'),
        confirmBtnName: '데이터 제공 내역 보기',
        onClickConfirmBtn: () =>
          navigate(ROUTE_PATH.mypage.manageLoanDataProvide + '?tab=dataUse'),
      },

      noExistAmt: {
        contents: message,
        cancelBtnName: '닫기',
        onClickCancelBtn: () => navigate('/'),
        confirmBtnName: '정산 예정금 보기',
        onClickConfirmBtn: () =>
          navigate(ROUTE_PATH.mypage.estimatedAmountManage),
      },

      checkAddMall: {
        contents: message,
        cancelBtnName: '닫기',
        onClickCancelBtn: () => navigate('/'),
        confirmBtnName: '추가 담보 확인하기',
        onClickConfirmBtn: () => {
          if (detailSeq.creditRequestSeq) {
            navigate(ROUTE_PATH.mypage.manageLoanDataProvide + '?tab=loan', {
              state: {
                parentPage: 'addMallDataProvider',
                creditRequestSeq: detailSeq.creditRequestSeq,
              },
            });
          } else if (detailSeq.dataProvideAgreeSeq) {
            navigate(ROUTE_PATH.mypage.manageLoanDataProvide + '?tab=dataUse', {
              state: {
                parentPage: 'addMallDataProvider',
                dataProvideAgreeSeq: detailSeq.dataProvideAgreeSeq,
              },
            });
          } else {
            // 방어코드: seq가 오지 않을 경우 목록으로 이동
            navigate(ROUTE_PATH.mypage.manageLoanDataProvide);
          }
        },
      },
      // 미확인 상태 예외 케이스(errorNo: 500)
      // 데이터 제공 기한 만료 케이스 (errorNo: 100)
      // 사업자 유효성 체크 (errorNo: 100)
      // 만료된 추가 담보몰일 경우 RSC400
      etcCase: {
        contents: message,
        confirmBtnName: errorNo === 500 ? '데이터 제공동의 확인하기' : '확인',
        onClickCloseBtn: () => navigate('/'),
        onClickConfirmBtn: () => {
          if (errorNo === 500) {
            window.location.reload(); // 데이터 제공동의 페이지 이동
          } else {
            setModalData(null);
            navigate('/');
          }
        },
      },
      infoToolTip: {
        textAlign: 'left',
        fontWeight: 400,
        contents: `${
          agreeDetailData?.dataProvideType === 'SECURED'
            ? '<strong>담보 판매몰 안내</strong>'
            : '<strong>데이터 제공 판매몰 안내</strong>'
        }
판매몰 연동은 '연동완료' 상태의 판매몰만 표시됩니다.
${
  isDisagreeCase &&
  agreeDetailData?.dataProvideType === 'SECURED' &&
  agreeDetailData.prejudgementTypeCd === 'JTC100'
    ? `정산예정금은 실제 정산예정금이 없거나, 해당 판매몰의 정산예정금을 담보로 대출이 진행 중인 경우 0원으로 노출됩니다.
`
    : ''
}하나의 판매몰에 여러 계정이 연결된 경우, 각 계정의 아이디가 표시되며, 아이디가 5자 이상일 경우 말줄임표(...)로 축약되어 표시됩니다.`,
      },
    };

    return modalDataMap[modalName] || null;
  };

  //동의 약관 보기
  const onClickViewBtn = stipulationSeq => {
    if (!!stipulationSeq) {
      window.open(`${deepLink.policyDefault}/${stipulationSeq}`, '_blank');
    }
  };

  const onClickInfoToolTip = () => {
    setModalData(getModalData('infoToolTip'));
  };

  const prejudgementType =
    agreeDetailData.dataProvideType === 'UNSECURED'
      ? sellerMallList.length > 0
        ? 'mall'
        : 'none'
      : agreeDetailData.prejudgementTypeCd;

  const getMainNoticeContents = type => {
    return type === 'ADD_MALL' ? (
      <Contents>
        <NoticeTitle>[주요 안내]</NoticeTitle>
        <List>
          {KEY_GUIDE[type].map((text, idx) => (
            <Text key={idx}>{text}</Text>
          ))}
        </List>
      </Contents>
    ) : (
      <Contents>
        {KEY_GUIDE[agreeDetailData.dataProvideType]?.[prejudgementType]}
      </Contents>
    );
  };

  const tableHead = [
    '판매몰',
    '담보 기간',
    agreeDetailData.prejudgementTypeCd === 'JTC100'
      ? '정산 예정금'
      : '누적 매출액',
  ];

  const tableHead2 = [
    '판매몰',
    agreeDetailData?.dataProvideType === 'SECURED'
      ? '담보 요청 기간'
      : '데이터 제공 요청 기간',
  ];

  const tableHead3 = ['판매몰', '데이터 제공 기간'];

  useEffect(() => {
    if (dataAgreeType === 'DEFAULT') {
      // 데이터 제공 동의 seq로 조회
      if (localDataProvideAgreeSeq) getDataProviderAgreeRequest();
      // 정적 타입 - 딥링크 생성 에러가 발생한 케이스
      if (goodsData.errorCode)
        handleApiError(goodsData.errorCode, goodsData.message);
    } else if (dataAgreeType === 'ADD_MALL') {
      if (!isLogin) {
        goToLoginPage();
      } else {
        getAddMallAgreeRequest();
      }
    }
  }, [localDataProvideAgreeSeq, goodsData.errorCode, dataAgreeType, isLogin]);

  useEffect(() => {
    // 잘못된 접근 처리
    if (dataAgreeType === 'DEFAULT') {
      const timer = setTimeout(() => {
        if (!localDataProvideAgreeSeq && !goodsData.errorCode) {
          navigate('/');
        }
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [localDataProvideAgreeSeq, goodsData.errorCode]);

  return (
    <Layout pageTitle="main" isShowBannerPage={false} onlyLogo={true}>
      {/*컨텐츠 없이 모달창만 띄우기*/}
      {onlyModal ? (
        <></>
      ) : (
        <DeepLinkAgreeWrapper>
          {isDisagreeCase ? (
            <>
              <TextMedium>
                <ColorSpan>
                  {agreeDetailData.businessName || auth.businessName}
                </ColorSpan>
                님
                <br />
                <ColorSpanRed>데이터 제공 동의가 불가</ColorSpanRed>합니다.
              </TextMedium>
              <DisagreeNoticeBox>
                <ColorSpan>{agreeDetailData.financeInstitutionName}</ColorSpan>
                의 대출 서비스 이용을 위한 데이터 제공 동의 정보가
                <ColorSpan>
                  {` ${agreeDetailData.businessName || auth.businessName}`}
                </ColorSpan>
                님의 정보와 일치하지 않습니다.
                <br />
                연동이 완료되지 않은 판매몰이 있다면, 먼저 연동을 진행해 주세요.
                <br />
                자세한 사항은 금융기관 혹은 고객센터로 문의해 주세요.
              </DisagreeNoticeBox>
            </>
          ) : (
            <>
              <TextMedium>
                <ColorSpan>
                  {agreeDetailData.businessName || auth.businessName}
                </ColorSpan>
                님
                <br />
                {dataAgreeType === 'ADD_MALL'
                  ? '담보 추가 데이터 제공동의를 진행해 주세요.'
                  : '데이터 제공동의를 진행해 주세요.'}
              </TextMedium>
              <Contents color={'#666'}>
                <ColorSpan>{agreeDetailData.financeInstitutionName}</ColorSpan>
                {agreeDetailData.financeInstitutionName && '의 '}대출 서비스
                이용을 위해 내용을 확인한 후 하단 버튼을 클릭하여 동의해 주세요.
              </Contents>
            </>
          )}

          {/* 비담보-매출액 기준이면 테이블 노출 안함 */}
          {agreeDetailData?.dataProvideType === 'UNSECURED' &&
          agreeDetailData.prejudgementTypeCd === 'JTC200' &&
          sellerMallList.length === 0 ? null : (
            <>
              <InfoToolTip onClick={onClickInfoToolTip}>
                {agreeDetailData?.dataProvideType === 'SECURED'
                  ? '담보 판매몰 안내'
                  : '데이터 제공 판매몰 안내'}{' '}
                <FeatherIcon
                  icon="help-circle"
                  size={16}
                  stroke="#737171"
                  strokeWidth={2}
                />
              </InfoToolTip>
              <DataProviderTable
                tableHead={
                  agreeDetailData?.dataProvideType === 'SECURED'
                    ? tableHead
                    : tableHead3
                }
                dataProviderList={sellerMallList}
                tableDataType={
                  agreeDetailData?.dataProvideType === 'SECURED'
                    ? 'threeCell'
                    : 'twoCell'
                }
              />
            </>
          )}

          {targetMallList.length > 0 && (
            <>
              <TextLeftAlign style={{ paddingBottom: '0' }}>
                <ColorSpan>{agreeDetailData.financeInstitutionName}</ColorSpan>{' '}
                요청 판매몰 안내
                <br />
                <em>{essentialMallText}</em>
              </TextLeftAlign>

              <DataProviderTable
                tableHead={tableHead2}
                dataProviderList={targetMallList}
                tableDataType="twoCell"
              />
            </>
          )}

          {!isDisagreeCase && getMainNoticeContents(dataAgreeType)}

          {isDisagreeCase ? (
            <></>
          ) : isCheckBoxType ? (
            <CheckableTypeStipulation
              stipulationList={stipulationList}
              setStipulationList={setStipulationList}
              onClickViewBtn={onClickViewBtn}
            />
          ) : (
            <TextTypeStipulation
              stipulationList={stipulationList}
              setStipulationList={setStipulationList}
            />
          )}
          {isDisagreeCase ? (
            <StyledActiveButton tabIndex={0} onClick={() => navigate('/')}>
              확인
            </StyledActiveButton>
          ) : (
            <StyledActiveButton
              tabIndex={0}
              onClick={() => onClickAgreeBtn(dataAgreeType)}
              disabled={isAgreeBtnDisabled || isApiLoading}
            >
              {isApiLoading ? <LoadingBar message={true} /> : '동의하기'}
            </StyledActiveButton>
          )}
          <TextButton
            tabIndex={0}
            title="데이터 제공 동의 거절 처리"
            onClick={() => {
              setModalData(getModalData('rejectAgreement'));
            }}
          >
            데이터 제공 동의 거절하기
          </TextButton>
        </DeepLinkAgreeWrapper>
      )}
    </Layout>
  );
};

export default DeepLinkAgreePage;
